import { AloftPrice, applyRoundingAndThresholds } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectAdjustmentSettings } from '../orderSelectors.ts';
import { createPriceSelector } from '../utils/createPriceSelector.ts';
import { selectFullBathsAdj } from './selectFullBathsAdj.ts';
import { selectHalfBathsAdj } from './selectHalfBathsAdj.ts';
import { getColorFromAdjustment } from './utils/getColorFromAdjustment.ts';
import { getStringValueFromAdjustment } from './utils/getStringValueFromAdjustment.ts';

const calculateBathsAdj = (
  fullBathsAdj: AloftPrice = AloftPrice.zero,
  halfBathsAdj: AloftPrice = AloftPrice.zero,
) => [fullBathsAdj, halfBathsAdj].reduce((acc: AloftPrice, curr) => acc.add(curr), AloftPrice.zero);

const selectBathsAdj = createPriceSelector(
  [selectFullBathsAdj, selectHalfBathsAdj],
  calculateBathsAdj,
);

const selectAppliedBathsAdj = createPriceSelector(
  [selectBathsAdj, selectAdjustmentSettings],
  (adj, adjSettings) => applyRoundingAndThresholds(adj, 'bathAboveGrade', adjSettings),
);

export const selectAppliedBathsAdjDisplay = createSelector([selectAppliedBathsAdj], (adj) => {
  if (!adj) return undefined;

  return {
    value: getStringValueFromAdjustment(adj),
    color: getColorFromAdjustment(adj),
  };
});
